module.exports = __webpack_public_path__ + "static/TownOfLight4-f93ee60585adeb1411cdf53b2d33cded.webp";